 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"3":true,"5":"viz-chart-visualization-clickable_image","6":"viz-chart-visualization-free_text_poll","7":"viz-chart-visualization-join_instructions","8":"viz-chart-visualization-survey","40":"activate-svg","41":"activity-svg","48":"amazon-svg","49":"apple-svg","51":"archetype-creator-presenter-svg","52":"archetype-creator-svg","53":"archetype-manager-svg","54":"archetype-other-svg","55":"archetype-presenter-svg","56":"archetype-unsure-svg","58":"blog-svg","61":"bulb-svg","63":"business-svg","65":"clickable-image-svg","66":"coca-cola-svg","67":"competition-svg","74":"corporate-svg","76":"duke-svg","77":"education-svg","79":"email_outline-svg","80":"enterprise-svg","81":"event-svg","82":"facebook_outline-svg","83":"features-svg","86":"google-svg","88":"harvard-svg","89":"higher-ed-svg","90":"home-logo-svg","92":"hp-svg","93":"info-svg","95":"k12-svg","96":"legacy-activity-states-mcp-corrected-locked-svg","97":"legacy-activity-states-mcp-options-ideal-svg","98":"legacy-activity-states-mcp-results-ideal-svg","99":"legacy-activity-states-mcp-results-locked-svg","100":"legacy-arrow-line-svg","101":"legacy-diamond-blue-svg","102":"legacy-error-red-svg","103":"legacy-info-blue-svg","104":"legacy-ok-green-svg","105":"legacy-pe-logo-icon-black-svg","106":"legacy-pe-logo-icon-blue-svg","107":"legacy-pe-logo-icon-white-svg","108":"legacy-pe-logo-lockup-black-svg","109":"legacy-pe-logo-lockup-blue-svg","110":"legacy-pe-logo-lockup-white-svg","111":"legacy-picker-cip-svg","112":"legacy-picker-competition-svg","113":"legacy-picker-mcp-short-svg","114":"legacy-picker-mcp-svg","115":"legacy-picker-more-svg","116":"legacy-picker-oe-short-svg","117":"legacy-picker-oe-svg","118":"legacy-picker-rp-short-svg","119":"legacy-picker-rp-svg","120":"legacy-picker-survey-svg","121":"legacy-picker-updown-short-svg","122":"legacy-picker-updown-svg","123":"legacy-picker-wc-short-svg","124":"legacy-picker-wc-svg","125":"legacy-share-team-svg","126":"legacy-sync-green-svg","127":"legacy-warning-yellow-svg","129":"linkedin_outline-svg","134":"multiple-choice-svg","144":"open-ended-svg","146":"other-svg","155":"picker-cip-svg","156":"picker-competition-svg","157":"picker-mcp-svg","158":"picker-open-ended-svg","159":"picker-survey-svg","160":"picker-updown-svg","161":"picker-word-cloud-svg","167":"present-svg","168":"profile-svg","169":"qa-svg","170":"ranking-svg","171":"registration-svg","172":"remote-audience-svg","173":"remote-svg","176":"resource-svg","177":"response-history-svg","180":"setup-wizard-svg","184":"spotify-svg","185":"support-svg","188":"target-svg","190":"thumb-down-filled-svg","191":"thumb-down-svg","192":"thumb-up-filled-svg","193":"thumb-up-svg","195":"twitter_outline-svg","196":"ucla-svg","198":"verizon-svg","199":"video-svg","200":"viz-title","202":"word-cloud-svg"}[chunkId]||chunkId) + "-" + {"1":"08376e45fc695786eb71","2":"59ba24d4d993e531aa27","3":"27fbf83f0ea3bba84e60","4":"b3d7fd7ce355f1ae1eeb","5":"5e1ab630096f1161d8a5","6":"fd1d48a02ed85e263e10","7":"da2438d2c90161864535","8":"331b622166937b1f6fac","9":"96cb363f4bba7729c423","10":"4c447908adf7a65c7326","11":"a6b9eedb9cc2bef7b53d","40":"3b2945489149c5442fe5","41":"369a6be0e9fff4da51ed","48":"a3395bd5d5e24e4dc20a","49":"a428d35048511e72c316","51":"6c2ada4e14bd55e5f8e0","52":"87c57c2e139630ec7c60","53":"bd26a2bf4c173f4d9902","54":"62445bacd2d15a30e5e3","55":"8396715e7a7bfecacec0","56":"b0c116a47f2a9fb66952","58":"b6e208fd488e8225ed36","61":"c60e146eb75dc2e8cff4","63":"e63b5088eba994d4227e","65":"0ed73105fd293d261cdc","66":"198aec90c78b449688b4","67":"3cc12fd7c55a07bfd0b1","74":"1bd559e18a73024743e3","76":"5b047ea18c74d3d89f3c","77":"ad3b16a2318fec4ab0a3","79":"349ac9439258b3ef7338","80":"220581e147fa984ed297","81":"3d993d0761875272372a","82":"89b28d95a015d77ccbbe","83":"775f96f6da435466a011","86":"d2fc60bfe1d36ccffff8","88":"2bedc9fec7bf56c5aa61","89":"3f40bc8601eea943fd2f","90":"59fb36bda780e424c448","92":"d7976f8db273bdab8ca1","93":"dd6a7b3c2aee4a1af94a","95":"f679af75af1e148b655d","96":"daeec0cd00aa12f5bf76","97":"b2b2b70a08529a46c437","98":"9199341f87cb55016082","99":"7e786c64d6a22587a3ab","100":"c25c8690a4c36b99d84f","101":"08c909c3121b1d1c6215","102":"3e8e6124337d25bf9535","103":"72df3b272a8e20dd88b8","104":"075eb9968087766d5a79","105":"cea7db83a4d695bb7ae3","106":"76b111f9c15273d03d7e","107":"602d541c3fc22f054cc0","108":"d99e0a72b94bb11f164a","109":"879a796c774dfdd772bc","110":"6599018eb70aa9442e8c","111":"a07ac59dc3c05f187b65","112":"88805a6f31e86752120f","113":"3e0671e43cb7015f8440","114":"a5ced671258255893f60","115":"3fad64e68844a96d77a5","116":"bf71f04b04619803d207","117":"c9fd3ed9c23d282dd314","118":"1576dbdbd406f8b0fb6d","119":"d670d0aa24008fa683a8","120":"f39c40431f01599a614b","121":"d2d01a8480960e6a17ae","122":"c51148d4eb59b668296e","123":"a61d1a11380a01655969","124":"91035dd34c016accdb86","125":"d641bbc50da5a630f019","126":"06a4aa278ec5b347bfd4","127":"4160de1e38f925761cdd","129":"46f9ff37ce9aff475d82","134":"070804135ba79a3ce1bc","144":"4bcb1acca0738c700f91","146":"b1671f23c49baefdd076","155":"1030f8d1e72e28b2265b","156":"d2abfc9cf6367c5a46f5","157":"46fd2574214b8f7d9dda","158":"dcb5d297642479af0394","159":"5df7beb24b9b071e6939","160":"eadb0a522d8e5ae77736","161":"196ae0feece93ea47899","167":"294870a4b941bd670b5f","168":"acaa969f918894800f28","169":"f78abf3272adbcba839c","170":"1dee6282b211a81f1ddf","171":"db34ea52fc771b2fc626","172":"1ed2c0c706ce95e2681f","173":"342a8b9174598ad09412","176":"98779269f6e6a7563078","177":"7020cf7f677c80d0fdca","180":"3a2739c624aa314b8182","184":"bae9357edbef4941e2d5","185":"ed7de7c7b1d721780eff","188":"a89b70d84a8127c689a4","190":"53e3e643cf4333bc597e","191":"076cd878e3bac5953cd4","192":"b200d164914e64e99e97","193":"ca2883e0def91c2b0476","195":"7a7ce0aee9e414b9d419","196":"772298f5ab794cf811a5","198":"6fb815c2c4abcb16e186","199":"b91c31daebd0f632021c","200":"7938dfdb1527035ddd91","202":"d3e3519b15207d10aa6b","204":"e96d760982ec47ec9ad2","205":"568bc4c37e416ee6379a","206":"2b94f52012b3bed1998d","207":"f5690d9c61744e072a89","208":"ec81f8a8aecab8c017b8","209":"217ecf0c72e62253e4fa","210":"31c14dc79704d05b9b0e"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1,"5":1,"6":1,"8":1,"9":1,"10":1,"11":1,"200":1,"204":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"3":true,"5":"viz-chart-visualization-clickable_image","6":"viz-chart-visualization-free_text_poll","7":"viz-chart-visualization-join_instructions","8":"viz-chart-visualization-survey","40":"activate-svg","41":"activity-svg","48":"amazon-svg","49":"apple-svg","51":"archetype-creator-presenter-svg","52":"archetype-creator-svg","53":"archetype-manager-svg","54":"archetype-other-svg","55":"archetype-presenter-svg","56":"archetype-unsure-svg","58":"blog-svg","61":"bulb-svg","63":"business-svg","65":"clickable-image-svg","66":"coca-cola-svg","67":"competition-svg","74":"corporate-svg","76":"duke-svg","77":"education-svg","79":"email_outline-svg","80":"enterprise-svg","81":"event-svg","82":"facebook_outline-svg","83":"features-svg","86":"google-svg","88":"harvard-svg","89":"higher-ed-svg","90":"home-logo-svg","92":"hp-svg","93":"info-svg","95":"k12-svg","96":"legacy-activity-states-mcp-corrected-locked-svg","97":"legacy-activity-states-mcp-options-ideal-svg","98":"legacy-activity-states-mcp-results-ideal-svg","99":"legacy-activity-states-mcp-results-locked-svg","100":"legacy-arrow-line-svg","101":"legacy-diamond-blue-svg","102":"legacy-error-red-svg","103":"legacy-info-blue-svg","104":"legacy-ok-green-svg","105":"legacy-pe-logo-icon-black-svg","106":"legacy-pe-logo-icon-blue-svg","107":"legacy-pe-logo-icon-white-svg","108":"legacy-pe-logo-lockup-black-svg","109":"legacy-pe-logo-lockup-blue-svg","110":"legacy-pe-logo-lockup-white-svg","111":"legacy-picker-cip-svg","112":"legacy-picker-competition-svg","113":"legacy-picker-mcp-short-svg","114":"legacy-picker-mcp-svg","115":"legacy-picker-more-svg","116":"legacy-picker-oe-short-svg","117":"legacy-picker-oe-svg","118":"legacy-picker-rp-short-svg","119":"legacy-picker-rp-svg","120":"legacy-picker-survey-svg","121":"legacy-picker-updown-short-svg","122":"legacy-picker-updown-svg","123":"legacy-picker-wc-short-svg","124":"legacy-picker-wc-svg","125":"legacy-share-team-svg","126":"legacy-sync-green-svg","127":"legacy-warning-yellow-svg","129":"linkedin_outline-svg","134":"multiple-choice-svg","144":"open-ended-svg","146":"other-svg","155":"picker-cip-svg","156":"picker-competition-svg","157":"picker-mcp-svg","158":"picker-open-ended-svg","159":"picker-survey-svg","160":"picker-updown-svg","161":"picker-word-cloud-svg","167":"present-svg","168":"profile-svg","169":"qa-svg","170":"ranking-svg","171":"registration-svg","172":"remote-audience-svg","173":"remote-svg","176":"resource-svg","177":"response-history-svg","180":"setup-wizard-svg","184":"spotify-svg","185":"support-svg","188":"target-svg","190":"thumb-down-filled-svg","191":"thumb-down-svg","192":"thumb-up-filled-svg","193":"thumb-up-svg","195":"twitter_outline-svg","196":"ucla-svg","198":"verizon-svg","199":"video-svg","200":"viz-title","202":"word-cloud-svg"}[chunkId]||chunkId) + "-" + {"1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"284efcc2","5":"20b4d297","6":"8b57a61c","7":"31d6cfe0","8":"87dd90f5","9":"9eadeed6","10":"79c30f66","11":"3d5a7f9b","40":"31d6cfe0","41":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","58":"31d6cfe0","61":"31d6cfe0","63":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","74":"31d6cfe0","76":"31d6cfe0","77":"31d6cfe0","79":"31d6cfe0","80":"31d6cfe0","81":"31d6cfe0","82":"31d6cfe0","83":"31d6cfe0","86":"31d6cfe0","88":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0","92":"31d6cfe0","93":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"31d6cfe0","99":"31d6cfe0","100":"31d6cfe0","101":"31d6cfe0","102":"31d6cfe0","103":"31d6cfe0","104":"31d6cfe0","105":"31d6cfe0","106":"31d6cfe0","107":"31d6cfe0","108":"31d6cfe0","109":"31d6cfe0","110":"31d6cfe0","111":"31d6cfe0","112":"31d6cfe0","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"31d6cfe0","126":"31d6cfe0","127":"31d6cfe0","129":"31d6cfe0","134":"31d6cfe0","144":"31d6cfe0","146":"31d6cfe0","155":"31d6cfe0","156":"31d6cfe0","157":"31d6cfe0","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0","180":"31d6cfe0","184":"31d6cfe0","185":"31d6cfe0","188":"31d6cfe0","190":"31d6cfe0","191":"31d6cfe0","192":"31d6cfe0","193":"31d6cfe0","195":"31d6cfe0","196":"31d6cfe0","198":"31d6cfe0","199":"31d6cfe0","200":"2d979f06","202":"31d6cfe0","204":"cd1ba5b2","205":"31d6cfe0","206":"31d6cfe0","207":"31d6cfe0","208":"31d6cfe0","209":"31d6cfe0","210":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "PLACEHOLDER_CDN_URL_PLACEHOLDER/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
